// import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import Container from "@saleor/components/Container";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
// import { SaleListUrlSortField } from "@saleor/discounts/urls";
// import { sectionNames } from "@saleor/intl";
import { RegisterList_recommend_edges_node } from "@saleor/register/types/RegisterList";
import { RegisterListUrlSortField } from "@saleor/register/urls";
import {
  FilterPageProps,
  ListActions,
  PageListProps,
  SortPage,
  TabPageProps
} from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

// import { SaleList_sales_edges_node } from "../../types/SaleList";
import RegisterList from "../RegisterList";
import {
  RegistercreateFilterStructure,
  RegisterFilterKeys,
  RegisterFilterOpts
} from "./filters";

export interface RegisterListPageProps
  extends PageListProps,
    ListActions,
    FilterPageProps<RegisterFilterKeys, RegisterFilterOpts>,
    // SortPage<RegisterListUrlSortField>,
    SortPage<RegisterListUrlSortField>,
    TabPageProps {
  defaultCurrency: string;
  registers: RegisterList_recommend_edges_node[];
  toatlCount: number;
}
// RegisterListProps
const RegisterPage: React.FC<RegisterListPageProps> = ({
  currencySymbol,
  currentTab,
  filterOpts,
  initialSearch,
  onAdd,
  onAll,
  onFilterChange,
  onSearchChange,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  toatlCount,
  ...listProps
}) => {
  const intl = useIntl();

  const structure = RegistercreateFilterStructure(intl, filterOpts);

  return (
    <Container>
      <PageHeader
        title={
          intl.formatMessage({
            defaultMessage: "All RecommendEvent"
          }) +
          "(" +
          toatlCount +
          ")"
        }
      >
        {/* <Button onClick={onAdd} variant="contained" color="primary">
          <FormattedMessage defaultMessage="Create Sale" description="button" />
        </Button> */}
      </PageHeader>
      <Card>
        <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All Recommend",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          filterStructure={structure}
          initialSearch={initialSearch}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Recommend"
          })}
          tabs={tabs}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <RegisterList {...listProps} />
      </Card>
    </Container>
  );
};
RegisterPage.displayName = "RegisterPage";
export default RegisterPage;
